export default "__VITE_ASSET__MAJpfh1G__"